import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { API } from "../App";

export function usePageView() {
  const location = useLocation();
  const prev = useRef(null);

  useEffect(() => {
    if (location.pathname === prev.current) return;
    prev.current = location.pathname;
    axios.post(`${API}/analytics/pageview`, { page: location.pathname }).catch(() => {});
  }, [location.pathname]);
}
